module.exports = __webpack_public_path__ + "static/media/address.1816781b.svg";